import * as React from 'react';
import { I18n } from 'react-redux-i18n';

import { QuestionnaireFamilyBuilderPageUpdateDto } from '@common/dto/questionnaire/page/family-builder/update-dto';
import { FamilyBuilderPageProps } from "./family-builder-page.types";

export const useFamilyBuilderPageController = (props: FamilyBuilderPageProps) => {
  const { data, onChange, showErrorMessage, cachedData, getPage } = props;
  const [loadingPage, setLoadingPage] = React.useState(false);

  const initializeData = async () => {
    setLoadingPage(true);

    if (!cachedData) {
      try {
        await getPage(data.id);
      } catch (err) {
        console.error(err);
        showErrorMessage(I18n.t('Failed to get page'))
      }
    }
    
    setLoadingPage(false);
  };

  React.useEffect(() => {
    initializeData();
  }, [data.id]);

  const updatePage = React.useCallback((dataToUpdate: Partial<QuestionnaireFamilyBuilderPageUpdateDto>) => {
    if (cachedData) {
      onChange({
        ...cachedData,
        ...dataToUpdate,
        modified: true,
      });
    }
  }, [cachedData, onChange]);

  const handlePageNameChange = React.useCallback((val: string) => {
    updatePage({
      title: val.trim()
    });
  }, [updatePage]);

  const handlePageDescriptionChange = React.useCallback((val: string) => {
    updatePage({
      description: val
    });
  }, [updatePage]);

  return {
    loadingPage,
    handlePageNameChange,
    handlePageDescriptionChange,
  };
};